import services from 'utils/mockAdapter';
// user list
const jobs = [
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 1 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 0,
        in_alert: 1
    },
    {
        id: '10012',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 2 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 0,
        in_alert: 1
    },
    {
        id: '10013',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 3 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 1,
        in_alert: 0
    },
    {
        id: '10014',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 4 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 0,
        in_alert: 1
    },
    {
        id: '10015',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 5 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 0,
        in_fault: 0,
        in_alert: 0
    },
    {
        id: '10016',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 6 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 0,
        in_alert: 1
    },
    {
        id: '10017',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 7 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 0,
        in_alert: 0
    },
    {
        id: '10018',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 8 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 0,
        in_alert: 0
    },
    {
        id: '10019',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 9 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 0,
        in_alert: 0
    },
    {
        id: '10020',
        manufacturer: 'Savaria',
        name: 'Sample Jobe 1 ',
        model: 'Eclipse',
        dealer: 'dealer 1',
        last_connection_at: '22-Jan-2022 19:21',
        connected: 1,
        in_fault: 1,
        in_alert: 0
    }
];

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/job-list/list').reply(200, { jobs });
